export default {
  fromStore(linksToDelete, ganttInstance) {
    ganttInstance.batchUpdate(() => {
      linksToDelete.forEach(link => {
        if (!ganttInstance.isLinkExists(link.id)) {
          return;
        }

        ganttInstance.silent(() => {
          ganttInstance.deleteLink(link.id);
          ganttInstance.sync_link_delete(link);
        });
      });
    });
  },

  fromGantt(links, ganttInstance) {

  },
};
